<template>
  <!-- Step 4: + bulk selection / group delete (shell selected + removegroup). -->
  <div class="clm" :class="{ 'clm--selecting': selectionMode }" dir="rtl">
    <div class="clm__header">
      <div class="clm__bar">
        <div class="clm__bar-actions">
          <button
            type="button"
            class="clm__bar-btn clm__bar-btn--create"
            :aria-label="
              customerList.personnel == 'active'
                ? $t('new-user')
                : $t('newCustomer')
            "
            @click="goToNewCustomer"
          >
            <v-icon size="22" color="#5B7C99">mdi-plus</v-icon>
          </button>
        <button
          type="button"
          class="clm__bar-btn"
          :aria-label="$t('refresh')"
            @click="onRefreshTap"
        >
          <v-icon size="20" color="#37474F">mdi-refresh</v-icon>
        </button>
        </div>
        <h1 class="clm__title">
          {{
            customerList.titleProp
              ? $t(customerList.titleProp)
              : $t($route.name, { name: $store.state.studentLabel })
          }}
        </h1>
        <button
          type="button"
          class="clm__bar-btn clm__bar-btn--back"
          :aria-label="$t('back')"
          @click="goBack"
        >
          <v-icon size="22" color="#37474F">mdi-arrow-left</v-icon>
        </button>
      </div>

      <div class="clm__search-row">
      <div class="clm__search">
        <v-icon size="20" color="#90A4AE" class="clm__search-icon">
          mdi-magnify
        </v-icon>
        <input
          v-model="customerList.search"
          type="search"
          class="clm__search-input"
          :placeholder="$t('search')"
          autocomplete="off"
        />
        <button
          v-if="customerList.search"
          type="button"
          class="clm__search-clear"
          :aria-label="$t('clear')"
          @click="customerList.search = ''"
        >
          <v-icon size="16" color="#90A4AE">mdi-close</v-icon>
          </button>
        </div>
        <button
          type="button"
          class="clm__filter-btn"
          :class="{ 'clm__filter-btn--active': hasAnyFilter }"
          :aria-label="$t('filter')"
          @click="onFilterTap"
        >
          <v-icon
            size="22"
            :color="hasAnyFilter ? '#1565C0' : '#546E7A'"
          >
            mdi-filter-outline
          </v-icon>
        </button>
        <button
          type="button"
          class="clm__filter-btn"
          :class="{ 'clm__filter-btn--active': selectionMode }"
          :aria-label="$t('select')"
          @click="toggleSelectionMode"
        >
          <v-icon size="22" :color="selectionMode ? '#1565C0' : '#546E7A'">
            mdi-checkbox-multiple-marked-outline
          </v-icon>
        </button>
      </div>

      <div v-if="selectionMode" class="clm__select-bar" dir="rtl">
        <button
          type="button"
          class="clm__select-bar-btn"
          @click="selectAllLoaded"
        >
          <v-icon size="17" color="#5B7C99">mdi-check-all</v-icon>
          {{ $t("selectAllItems") }}
        </button>
        <span class="clm__select-count">
          {{ selectedItems.length }} {{ $t("selectedCount") }}
        </span>
        <button
          type="button"
          class="clm__select-bar-btn"
          @click="clearSelection"
        >
          <v-icon size="17" color="#90A4AE">mdi-close</v-icon>
          {{ $t("deselectAll") }}
        </button>
      </div>
    </div>

    <div v-if="customerList.loading && !displayItems.length" class="clm__state">
      <v-progress-circular indeterminate color="#5B7C99" size="28" />
    </div>
    <div v-else-if="!displayItems.length" class="clm__state clm__state--empty">
      <img
        class="clm__empty-logo"
        src="@/assets/dashboard/no-data-cloud.png"
        alt=""
      />
      <p class="clm__empty-text">{{ $t("no-data") }}</p>
    </div>
    <div v-else class="clm__list">
      <article
        v-for="(item, index) in displayItems"
        :key="item.id || index"
        class="clm-card"
        :class="{ 'clm-card--selected': selectionMode && isSelected(item) }"
      >
        <div
          v-if="selectionMode"
          class="clm-card__select-overlay"
          :class="{ 'clm-card__select-overlay--on': isSelected(item) }"
          @click="toggleSelect(item)"
        >
          <span v-if="isSelected(item)" class="clm-card__check">
            <v-icon size="17" color="#FFFFFF">mdi-check</v-icon>
          </span>
        </div>
        <div class="clm-card__head">
          <div class="clm-card__identity">
            <img
              class="clm-card__avatar"
              :src="avatarSrc(item)"
              alt=""
            />
            <button
              type="button"
              class="clm-card__name-link"
              @click="customerList.edit(item)"
            >
          <span class="clm-card__name">{{ item.name || "—" }}</span>
              <v-icon size="12" color="#879EB6">mdi-pencil-outline</v-icon>
            </button>
        </div>
          <span class="clm-card__number">#{{ item.id }}</span>
        </div>

        <div class="clm-card__amounts">
          <div class="clm-card__amount-row">
            <span class="clm-card__amount-label">{{ $t("category") }}</span>
            <span class="clm-card__amount-value">
              {{
                item.category && item.category.name
                  ? item.category.name
                : "—"
            }}
          </span>
        </div>
          <div
            v-if="item.mobile || item.phone"
            class="clm-card__amount-row"
          >
            <span class="clm-card__amount-label">{{ $t("mobile") }}</span>
            <span class="clm-card__amount-value">
              {{ item.mobile || item.phone }}
            </span>
          </div>
          <div class="clm-card__amount-row">
            <span class="clm-card__amount-label">{{ $t("remainPrice") }}</span>
            <span
              class="clm-card__amount-value"
              :class="remainToneClass(item)"
            >
              {{ remainText(item) }}
            </span>
          </div>
        </div>

        <div v-if="!selectionMode" class="clm-card__footer">
          <div class="clm-card__actions">
            <button
              v-show="removePermission('account')"
              type="button"
              class="clm-btn clm-btn--danger"
              @click="askDelete(item)"
            >
              <v-icon size="14" color="#E53935">mdi-trash-can-outline</v-icon>
              {{ $t("remove") }}
            </button>
            <button
              type="button"
              class="clm-btn clm-btn--primary"
              @click="customerList.edit(item)"
            >
              <v-icon size="14" color="#FFFFFF">mdi-pencil-outline</v-icon>
              {{ $t("edit") }}
            </button>
            <button
              type="button"
              class="clm-btn clm-btn--outline"
              @click="openDetails(item)"
            >
              <v-icon size="14" color="#5B7C99">mdi-eye-outline</v-icon>
              {{ $t("details") }}
            </button>
          </div>
          <span
            class="clm-status-btn"
            :class="'clm-status-btn--' + remainTone(item)"
          >
            {{ remainStatusLabel(item) }}
          </span>
        </div>
      </article>
      <div v-if="appending" class="clm__state clm__state--more">
        <v-progress-circular indeterminate color="#5B7C99" size="22" />
      </div>
    </div>

    <!-- Always in DOM (like invoice): observer must attach on mount even
         before the first page fills displayItems. -->
    <div ref="sentinel" class="clm__sentinel" />

    <div v-if="selectionMode" class="clm-bulkbar" dir="rtl">
      <button
        v-if="removePermission('account')"
        type="button"
        class="clm-bulkbar__btn clm-bulkbar__btn--danger"
        :disabled="!selectedItems.length"
        @click="askGroupDelete"
      >
        <v-icon size="19" color="#E53935">mdi-trash-can-outline</v-icon>
        {{ $t("groupDelete") }}
      </button>
    </div>

    <!-- Details sheet: customer fields + quick actions (same shell methods) -->
    <v-bottom-sheet v-model="detailSheet" scrollable>
      <v-card class="clm-sheet">
        <div class="clm-sheet__handle" />
        <div class="clm-sheet__header" dir="rtl">
          <div class="clm-sheet__header-side">
            <span v-if="detailItem" class="clm-sheet__num-chip">
              #{{ detailItem.id }}
            </span>
          </div>
          <div class="clm-sheet__title">{{ $t("details") }}</div>
          <div class="clm-sheet__header-side clm-sheet__header-side--end">
            <button
              type="button"
              class="clm-sheet__back"
              :aria-label="$t('back')"
              @click="detailSheet = false"
            >
              <v-icon size="22" color="#37474F">mdi-arrow-left</v-icon>
            </button>
          </div>
        </div>

        <div v-if="detailItem" class="clm-sheet__quickbar" dir="rtl">
          <button
            type="button"
            class="clm-sheet__quick"
            @click="runNamedAction('edit')"
          >
            <v-icon size="18" color="#5B7C99">mdi-pencil-outline</v-icon>
            {{ $t("edit") }}
          </button>
          <button
            type="button"
            class="clm-sheet__quick"
            @click="runNamedAction('openTaskDialog')"
          >
            <v-icon size="18" color="#5B7C99">
              mdi-notebook-plus-outline
            </v-icon>
            {{ $t("new-task") }}
          </button>
          <button
            type="button"
            class="clm-sheet__quick"
            @click="runNamedAction('pay')"
          >
            <v-icon size="18" color="#5B7C99">mdi-credit-card-outline</v-icon>
            {{ $t("payCash") }}
          </button>
          <button
            type="button"
            class="clm-sheet__quick"
            @click="runNamedAction('recieve')"
          >
            <v-icon size="18" color="#5B7C99">mdi-cash</v-icon>
            {{ $t("cashReceive") }}
          </button>
          <button
            type="button"
            class="clm-sheet__quick"
            @click="moreSheet = true"
          >
            <v-icon size="18" color="#5B7C99">mdi-dots-horizontal</v-icon>
            {{ $t("more") }}
          </button>
        </div>

        <div v-if="detailItem" class="clm-sheet__customer-block" dir="rtl">
          <div class="clm-sheet__customer-row">
            <span class="clm-sheet__row-label">{{ $t("name") }}</span>
            <span class="clm-sheet__customer-name">
              {{ detailItem.name || "—" }}
            </span>
          </div>
          <button
            type="button"
            class="clm-sheet__linkrow"
            @click="runNamedAction('turnover')"
          >
            <v-icon size="18" color="#00796B">mdi-playlist-check</v-icon>
            <span class="clm-sheet__linkrow-text">{{ $t("turnover") }}</span>
            <v-icon size="18" color="#80CBC4">mdi-chevron-left</v-icon>
          </button>
        </div>

        <div v-if="detailItem" class="clm-sheet__body" dir="rtl">
          <div class="clm-sheet__card">
            <div
              v-for="(row, i) in detailRows(detailItem)"
              :key="'detail-row-' + i"
              class="clm-sheet__row"
              :class="{ 'clm-sheet__row--band': row.kind === 'remain' }"
            >
              <span class="clm-sheet__row-label">{{ row.label }}</span>
              <span
                class="clm-sheet__row-value"
                :class="{
                  'clm-sheet__row-value--remain': row.kind === 'remain',
                  'clm-sheet__row-value--debtor': row.tone === 'debtor',
                  'clm-sheet__row-value--creditor': row.tone === 'creditor',
                }"
              >
                {{ row.value }}
              </span>
            </div>

            <!-- Same "سایر" / ID rows as desktop content column -->
            <div
              v-for="(idRow, ii) in detailIdRows(detailItem)"
              :key="'detail-id-' + ii"
              class="clm-sheet__row clm-sheet__row--id"
            >
              <span class="clm-sheet__row-label clm-sheet__id-label">
                <img
                  v-if="idRow.icon"
                  class="clm-sheet__id-icon"
                  :src="idRow.icon"
                  alt=""
                />
                {{ idRow.label }}
              </span>
              <button
                type="button"
                class="clm-sheet__row-value clm-sheet__id-value"
                v-clipboard:copy="String(idRow.value || '')"
                @click="onCopyId"
              >
                {{ idRow.value }}
              </button>
            </div>

            <div
              v-if="detailItem.expire_date"
              class="clm-sheet__row clm-sheet__row--chips"
            >
              <v-chip
                label
                color="pink"
                small
                class="px-1"
                @click="maybeOpenExtension(detailItem)"
              >
                <span class="px-1 white--text">
                  {{ $t("serviceExpireDate") }} : {{ detailItem.expire_date }}
                </span>
              </v-chip>
            </div>
            <div
              v-if="detailItem.plan_name"
              class="clm-sheet__row clm-sheet__row--chips"
            >
              <v-chip
                label
                color="primary"
                small
                class="px-1"
                @click="maybeOpenExtension(detailItem)"
              >
                <span class="px-1 white--text">
                  {{ $t("plan-name") }} : {{ detailItem.plan_name }}
                </span>
              </v-chip>
            </div>
            <div
              v-if="
                detailItem.custom_fields && detailItem.custom_fields.length
              "
              class="clm-sheet__row clm-sheet__row--chips"
            >
              <v-chip
                v-for="(field, fi) in detailItem.custom_fields"
                :key="'detail-cf-' + fi"
                label
                color="primary"
                small
                class="px-1"
              >
                <span class="px-1 white--text">
                  {{ field.key }} : {{ field.value }}
                </span>
              </v-chip>
            </div>
            <div
              v-if="detailItem.content"
              class="clm-sheet__row"
            >
              <span class="clm-sheet__row-label">{{ $t("other") }}</span>
              <span class="clm-sheet__row-value clm-sheet__row-value--muted">
                {{ detailContentPreview(detailItem) }}
              </span>
            </div>

            <div class="clm-sheet__row">
              <span class="clm-sheet__row-label">{{ $t("tag") }}</span>
              <span
                v-if="detailItem.tags && detailItem.tags.length"
                class="clm-sheet__tags"
              >
                <v-chip
                  v-for="(tag, ti) in detailItem.tags"
                  :key="'detail-tag-' + ti"
                  :color="tag.color || '#607D8B'"
                  label
                  small
                  class="px-1"
                >
                  <span class="px-1 white--text">{{ tag.text }}</span>
                </v-chip>
              </span>
              <span
                v-else
                class="clm-sheet__row-value clm-sheet__row-value--muted"
              >
                {{ $t("haveNot") }}
              </span>
            </div>
          </div>
        </div>
      </v-card>
    </v-bottom-sheet>

    <!-- Secondary actions from the desktop row menu -->
    <v-bottom-sheet v-model="moreSheet">
      <v-card class="clm-sheet">
        <div class="clm-sheet__handle" />
        <div class="clm-sheet__header" dir="rtl">
          <span class="clm-sheet__header-spacer" />
          <div class="clm-sheet__title">{{ $t("more") }}</div>
          <button
            type="button"
            class="clm-sheet__back"
            :aria-label="$t('back')"
            @click="moreSheet = false"
          >
            <v-icon size="22" color="#37474F">mdi-arrow-left</v-icon>
          </button>
        </div>

        <div v-if="detailItem" class="clm-sheet__body" dir="rtl">
          <div class="clm-sheet__actions clm-sheet__actions--sheet">
            <button
              v-if="$route.name == 'academyStudentList'"
              type="button"
              class="clm-sheet__action"
              @click="runMoreAction('events')"
            >
              <v-icon size="19" color="#5B7C99">mdi-school-outline</v-icon>
              {{ $t("academyEventList") }}
            </button>
            <button
              v-if="$route.name == 'academyTeacherList'"
              type="button"
              class="clm-sheet__action"
              @click="runMoreAction('teacherCostList')"
            >
              <v-icon size="19" color="#5B7C99">mdi-school-outline</v-icon>
              {{ $t("academyTeacherSessionCostList") }}
            </button>
            <button
              type="button"
              class="clm-sheet__action"
              @click="runMoreAction('openTaskDialogList')"
            >
              <v-icon size="19" color="#5B7C99">
                mdi-format-list-bulleted-square
              </v-icon>
              {{ $t("tasks") }}
              <span
                v-if="detailItem.taskCount"
                class="clm-sheet__action-badge"
              >
                {{ detailItem.taskCount }}
              </span>
            </button>
            <button
              type="button"
              class="clm-sheet__action"
              @click="runMoreAction('remainAccountSms')"
            >
              <v-icon size="19" color="#5B7C99">mdi-message-text-outline</v-icon>
              {{ $t("remainAccountSMS") }}
            </button>
            <button
              v-if="customerList.personnel"
              type="button"
              class="clm-sheet__action"
              @click="runMoreAction('openCardDialog')"
            >
              <v-icon size="19" color="#5B7C99">
                mdi-account-hard-hat-outline
              </v-icon>
              {{ $t("operationUser") }}
            </button>
            <button
              type="button"
              class="clm-sheet__action"
              v-clipboard:copy="$baseURL + '/customer/edit/' + detailItem.id"
              @click="onCopyLink"
            >
              <v-icon size="19" color="#5B7C99">mdi-link</v-icon>
              {{ $t("copy-link") }}
            </button>
            <div class="clm-sheet__action clm-sheet__action--log">
              <log
                :title-prop="$t('history')"
                icon-prop="mdi-history"
                :listProp="true"
                :type-prop="customerList.typeForm"
                :refIdProp="detailItem.id"
                mode-prop="button"
              />
            </div>
          </div>
        </div>
      </v-card>
    </v-bottom-sheet>

    <!-- Mobile delete confirmation: same shell remove()/removegroup() -->
    <v-bottom-sheet v-model="deleteSheet">
      <v-card class="clm-confirm-sheet" dir="rtl">
        <div class="clm-confirm-sheet__handle" />
        <div class="clm-confirm-sheet__icon">
          <v-icon size="26" color="#E53935">mdi-trash-can-outline</v-icon>
        </div>
        <div class="clm-confirm-sheet__title">
          {{ deleteGroupMode ? $t("groupDelete") : $t("delete") }}
        </div>
        <p class="clm-confirm-sheet__subtitle">
          {{ $t("are-you-sure-delete-this-case") }}
        </p>
        <div v-if="deleteGroupMode" class="clm-confirm-sheet__rows">
          <div class="clm-confirm-sheet__row">
            <span>{{ $t("totalCount") }}</span>
            <strong>{{ selectedItems.length }}</strong>
          </div>
          <div class="clm-confirm-sheet__items">
            <div
              v-for="(sel, si) in selectedItems"
              :key="'del-item-' + si"
              class="clm-confirm-sheet__item"
            >
              <span class="clm-confirm-sheet__item-main">
                <span class="clm-confirm-sheet__item-index">
                  {{ selectedRowNumber(sel) }}
                </span>
                <span class="clm-confirm-sheet__item-name">
                  {{ sel.name || "—" }}
                </span>
              </span>
              <span v-if="sel.code" class="clm-confirm-sheet__item-number">
                #{{ sel.code }}
              </span>
            </div>
          </div>
        </div>
        <div
          v-else-if="customerList.deleteItem"
          class="clm-confirm-sheet__rows"
        >
          <div class="clm-confirm-sheet__row">
            <span>{{ $t("name") }}</span>
            <strong>{{ customerList.deleteItem.name || "—" }}</strong>
          </div>
          <div
            v-if="customerList.deleteItem.code"
            class="clm-confirm-sheet__row"
          >
            <span>{{ $t("code") }}</span>
            <strong>{{ customerList.deleteItem.code }}</strong>
          </div>
          <div class="clm-confirm-sheet__row">
            <span>{{ $t("remainPrice") }}</span>
            <strong>{{ remainText(customerList.deleteItem) }}</strong>
          </div>
        </div>
        <div class="clm-confirm-sheet__actions">
          <v-btn
            color="error"
            block
            depressed
            height="48"
            class="clm-confirm-sheet__yes"
            @click="confirmDelete"
          >
            {{ $t("yes") }}
          </v-btn>
          <v-btn
            outlined
            block
            height="48"
            color="secondary"
            class="clm-confirm-sheet__no"
            @click="cancelDelete"
          >
            {{ $t("no") }}
          </v-btn>
        </div>
      </v-card>
    </v-bottom-sheet>

    <!-- Mobile filter: layered like InvoiceListMobile. Same shell filter
         fields + getItems; presentation only. -->
    <v-bottom-sheet v-model="filterSheet" scrollable>
      <v-card class="clm-sheet clm-sheet--filter">
        <div class="clm-sheet__handle" />
        <div class="clm-sheet__header" dir="rtl">
          <span class="clm-sheet__header-spacer" />
          <div class="clm-sheet__title">{{ $t("filter") }}</div>
          <button
            type="button"
            class="clm-sheet__back"
            :aria-label="$t('back')"
            @click="filterSheet = false"
          >
            <v-icon size="22" color="#37474F">mdi-arrow-left</v-icon>
          </button>
        </div>

        <div class="clm-filter-nav" dir="rtl">
          <button
            v-for="group in filterGroups"
            :key="group.key"
            type="button"
            class="clm-filter-nav__item"
            @click="openFilterGroup(group.key)"
          >
            <v-icon class="clm-filter-nav__icon" size="22" color="#5B7C99">
              {{ group.icon }}
            </v-icon>
            <span class="clm-filter-nav__texts">
              <span class="clm-filter-nav__item-title">{{ group.title }}</span>
              <span class="clm-filter-nav__item-sub">
                {{ groupSubtitle(group.key) }}
              </span>
            </span>
            <span v-if="groupHasValue(group.key)" class="clm-filter-nav__dot" />
            <v-icon size="20" color="#90A4AE">mdi-chevron-left</v-icon>
          </button>
        </div>

        <div class="clm-sheet__footer" dir="rtl">
          <button
            type="button"
            class="clm-sheet__btn clm-sheet__btn--primary"
            @click="applyFilter"
          >
            <v-icon size="16" color="#FFFFFF">mdi-filter-outline</v-icon>
            {{ $t("filter") }}
          </button>
          <button
            type="button"
            class="clm-sheet__btn clm-sheet__btn--ghost"
            @click="clearFilter"
          >
            <v-icon size="16" color="#5B7C99">mdi-filter-remove-outline</v-icon>
            {{ $t("clear") }}
          </button>
        </div>
      </v-card>
    </v-bottom-sheet>

    <v-bottom-sheet v-model="filterGroupSheet" scrollable>
      <v-card class="clm-sheet clm-sheet--filter">
        <div class="clm-sheet__handle" />
        <div class="clm-sheet__header" dir="rtl">
          <span class="clm-sheet__header-spacer" />
          <div class="clm-sheet__title">{{ activeFilterGroupTitle }}</div>
          <button
            type="button"
            class="clm-sheet__back"
            :aria-label="$t('back')"
            @click="backToFilterMain"
          >
            <v-icon size="22" color="#37474F">mdi-arrow-left</v-icon>
          </button>
        </div>

        <div class="clm-filter-fields" dir="rtl">
          <template v-if="filterGroup === 'status'">
            <div class="clm-toggle-row">
              <button
                type="button"
                class="clm-toggle"
                :class="{ 'clm-toggle--on': customerList.lead === 'active' }"
                @click="toggleFlag('lead')"
              >
                <span class="clm-toggle__label">{{ $t("lead") }}</span>
                <span class="clm-toggle__switch" aria-hidden="true" />
              </button>
              <button
                type="button"
                class="clm-toggle"
                :class="{ 'clm-toggle--on': customerList.status === 'active' }"
                @click="toggleFlag('status')"
              >
                <span class="clm-toggle__label">{{ $t("active") }}</span>
                <span class="clm-toggle__switch" aria-hidden="true" />
              </button>
            </div>
            <div class="clm-f-field-wrap">
              <div class="clm-f-field-wrap__label">
                {{ $t("financial-status") }}
              </div>
              <div class="clm-chip-row">
                <button
                  v-for="item in customerList.financialStatusItems || []"
                  :key="item.value"
                  type="button"
                  class="clm-chip"
                  :class="{
                    'clm-chip--on': customerList.financialStatus === item.value,
                  }"
                  @click="pickFinancialStatus(item.value)"
                >
                  {{ item.text }}
                </button>
              </div>
            </div>
          </template>

          <template v-else-if="filterGroup === 'category'">
            <div class="clm-f-field-wrap">
              <div class="clm-f-field-wrap__label">{{ $t("category") }}</div>
              <button
                type="button"
                class="clm-f-picker-field"
                @click="openPicker('acCategory')"
              >
                <span class="clm-f-picker-field__text">
                  {{ pickerSummary("acCategory", customerList.category) }}
                </span>
                <v-icon size="20" color="#78909C">mdi-chevron-down</v-icon>
              </button>
              <div class="clm-picker-host" aria-hidden="true">
                <autocomplete
                  ref="acCategory"
                  v-model="customerList.category"
                  :title="$t('category')"
                  type="accountCategory"
                  :multiple="true"
                  :filter="true"
                />
              </div>
            </div>
            <div class="clm-f-field-wrap">
              <div class="clm-f-field-wrap__label">
                {{ $t("attractionMethod") }}
              </div>
              <button
                type="button"
                class="clm-f-picker-field"
                @click="openPicker('acAttraction')"
              >
                <span class="clm-f-picker-field__text">
                  {{
                    pickerSummary("acAttraction", customerList.attractionMethod)
                  }}
                </span>
                <v-icon size="20" color="#78909C">mdi-chevron-down</v-icon>
              </button>
              <div class="clm-picker-host" aria-hidden="true">
                <autocomplete
                  ref="acAttraction"
                  v-model="customerList.attractionMethod"
                  :title="$t('attractionMethod')"
                  type="attractionMethod"
                  :multiple="true"
                  :filter="true"
                />
              </div>
            </div>
            <div class="clm-f-field-wrap">
              <div class="clm-f-field-wrap__label">{{ $t("tag") }}</div>
              <button
                type="button"
                class="clm-f-picker-field"
                @click="openPicker('acTag')"
              >
                <span class="clm-f-picker-field__text">
                  {{ pickerSummary("acTag", customerList.tag) }}
                </span>
                <v-icon size="20" color="#78909C">mdi-chevron-down</v-icon>
              </button>
              <div class="clm-picker-host" aria-hidden="true">
                <tag ref="acTag" v-model="customerList.tag" />
              </div>
            </div>
            <div class="clm-f-field-wrap">
              <div class="clm-f-field-wrap__label">{{ $t("branch") }}</div>
              <button
                type="button"
                class="clm-f-picker-field"
                @click="openPicker('acBranch')"
              >
                <span class="clm-f-picker-field__text">
                  {{ pickerSummary("acBranch", customerList.branch) }}
                </span>
                <v-icon size="20" color="#78909C">mdi-chevron-down</v-icon>
              </button>
              <div class="clm-picker-host" aria-hidden="true">
                <autocomplete
                  ref="acBranch"
                  v-model="customerList.branch"
                  title="branch"
                  type="branch"
                  :filter="true"
                  :multiple="true"
                />
              </div>
            </div>
          </template>

          <template v-else-if="filterGroup === 'registerar'">
            <div class="clm-f-field-wrap">
              <div class="clm-f-field-wrap__label">{{ $t("registerar") }}</div>
              <button
                type="button"
                class="clm-f-picker-field"
                @click="openPicker('acRegisterar')"
              >
                <span class="clm-f-picker-field__text">
                  {{ pickerSummary("acRegisterar", customerList.registerar) }}
                </span>
                <v-icon size="20" color="#78909C">mdi-chevron-down</v-icon>
              </button>
              <div class="clm-picker-host" aria-hidden="true">
                <autocomplete
                  ref="acRegisterar"
                  v-model="customerList.registerar"
                  :title="$t('registerar')"
                  type="partners"
                  :multiple="true"
                  :filter="true"
                />
              </div>
            </div>
          </template>

          <!-- Same model as desktop custom-field filter + InvoiceListMobile -->
          <template v-else-if="filterGroup === 'custom'">
            <div class="clm-cf__hint">
              {{ $t("clickForAddCustomeField") }}
            </div>

            <button
              type="button"
              class="clm-cf__add"
              @click="addFilterCustomField"
            >
              <v-icon size="18" color="#5B7C99">mdi-plus</v-icon>
              <span>{{ $t("addCustomeField") }}</span>
            </button>

            <div v-if="!filterCustomItems.length" class="clm-cf__empty">
              {{ $t("invoice-mobile-custom-fields-empty") }}
            </div>

            <div
              v-for="(item, index) in filterCustomItems"
              :key="'filter-custom-' + index"
              class="clm-cf-card"
            >
              <div class="clm-cf-card__type">
                <div class="clm-f-field-wrap clm-cf-card__type-field">
                  <div class="clm-f-field-wrap__label">
                    {{ $t("additionalFields") }}
                  </div>
                  <v-combobox
                    v-model="item.key"
                    :items="filterCustomKeyItems"
                    :search-input.sync="filterCustomSearch"
                    solo
                    flat
                    dense
                    hide-details
                    hide-selected
                    height="40"
                    append-icon="mdi-chevron-down"
                    class="clm-f-field"
                    @change="syncFilterCustomFields"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ $t("toCreate") }}: "<strong>{{
                              filterCustomSearch
                            }}</strong
                            >". {{ $t("doEnter") }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-combobox>
                </div>
                <button
                  type="button"
                  class="clm-cf-card__remove"
                  :aria-label="$t('remove')"
                  @click="removeFilterCustomField(index)"
                >
                  <v-icon size="20" color="#E91E63">mdi-close</v-icon>
                </button>
              </div>

              <div class="clm-f-field-wrap">
                <div class="clm-f-field-wrap__label">{{ $t("value") }}</div>
                <input
                  v-model="item.value"
                  type="text"
                  class="clm-cf-card__input clm-cf-card__input--text"
                  @input="syncFilterCustomFields"
                />
              </div>
            </div>
          </template>
        </div>

        <div class="clm-sheet__footer" dir="rtl">
          <button
            type="button"
            class="clm-sheet__btn clm-sheet__btn--primary"
            @click="backToFilterMain"
          >
            {{ $t("Save") }}
          </button>
        </div>
      </v-card>
    </v-bottom-sheet>

  </div>
</template>

<script>
export default {
  name: "CustomerListMobile",
  inject: ["customerList"],
  components: {
    // Same filter field components the shell registers for the desktop dialog
    autocomplete: () =>
      import("../../../../components/general/patial/autocomplete"),
    Tag: () => import("../../../../components/general/Tag/tag"),
  },
  data() {
    return {
      displayItems: [],
      appending: false,
      observer: null,
      detailSheet: false,
      moreSheet: false,
      detailItem: null,
      deleteSheet: false,
      deleteGroupMode: false,
      selectionMode: false,
      selectedItems: [],
      filterSheet: false,
      filterGroupSheet: false,
      filterGroup: null,
      filterCustomItems: [],
      filterCustomKeyItems: [],
      filterCustomSearch: null,
      filterCustomKeyTimer: null,
    };
  },
  computed: {
    currentPage() {
      const opts = this.customerList.tableOptions || {};
      return opts.page || 1;
    },
    filterGroups() {
      const groups = [
        {
          key: "status",
          icon: "mdi-check-circle-outline",
          title: this.$t("status"),
        },
        {
          key: "category",
          icon: "mdi-shape-outline",
          title: this.$t("category"),
        },
        {
          key: "registerar",
          icon: "mdi-account-outline",
          title: this.$t("registerar"),
        },
      ];
      if (this.customFieldsPermission) {
        groups.push({
          key: "custom",
          icon: "mdi-playlist-plus",
          title: this.$t("customFields"),
        });
      }
      return groups;
    },
    activeFilterGroupTitle() {
      const group = this.filterGroups.find((g) => g.key === this.filterGroup);
      return group ? group.title : this.$t("filter");
    },
    hasAnyFilter() {
      return (
        this.groupHasValue("status") ||
        this.groupHasValue("category") ||
        this.groupHasValue("registerar") ||
        this.groupHasValue("custom")
      );
    },
  },
  watch: {
    filterCustomSearch() {
      this.loadFilterCustomKeys();
    },
    "customerList.items"(val) {
      const items = val || [];
      if (this.appending) {
        const seen = {};
        this.displayItems.forEach((i) => {
          seen[i.id] = true;
        });
        this.displayItems = this.displayItems.concat(
          items.filter((i) => !seen[i.id])
        );
        this.appending = false;
      } else {
        this.displayItems = items.slice();
        // Fresh list (search/filter/refresh): drop local picks; shell
        // selected is only synced when a group action runs.
        this.selectedItems = [];
      }
    },
    "customerList.search"() {
      this.appending = false;
      if (this.currentPage !== 1) {
        this.customerList.tableOptions = Object.assign(
          {},
          this.customerList.tableOptions,
          { page: 1 }
        );
      }
    },
    deleteSheet(val) {
      if (!val) this.deleteGroupMode = false;
    },
  },
  mounted() {
    this.displayItems = (this.customerList.items || []).slice();
    // Same page size as desktop tableOptions; assignment triggers shell watcher.
    this.customerList.tableOptions = Object.assign(
      {},
      this.customerList.tableOptions,
      { page: 1, itemsPerPage: 10 }
    );
    this.$nextTick(() => {
      if (!("IntersectionObserver" in window) || !this.$refs.sentinel) return;
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0] && entries[0].isIntersecting) this.loadMore();
        },
        { rootMargin: "200px" }
      );
      this.observer.observe(this.$refs.sentinel);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  },
  methods: {
    goBack() {
      if (window.history.length > 1) this.$router.back();
      else this.$router.push({ name: "Home" }).catch(() => {});
    },
    goToNewCustomer() {
      // Same route/params as the desktop toolbar + button.
      this.$router.push({
        name: "customer",
        params: {
          personnelStatus: this.customerList.personnel,
          tabName:
            this.customerList.personnel === "active"
              ? this.$t("new-user")
              : this.$t("newCustomer"),
        },
      });
    },
    avatarSrc(item) {
      if (item && item.avatar && item.avatar.link) return item.avatar.link;
      try {
        return require("@/assets/Avatar.png");
      } catch (e) {
        return "";
      }
    },
    remainStatusLabel(item) {
      const tone = this.remainTone(item);
      if (tone === "debtor") return this.$t("debtor");
      if (tone === "creditor") return this.$t("creditor");
      return this.$t("clearing");
    },
    onRefreshTap() {
      this.appending = false;
      this.customerList.tableOptions = Object.assign(
        {},
        this.customerList.tableOptions,
        { page: 1 }
      );
      this.customerList.getItems();
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    onFilterTap() {
      this.filterSheet = true;
    },
    remainAmount(item) {
      if (!item || item.remain == null || item.remain === "") return null;
      if (typeof item.remain === "object") {
        return item.remain.remain != null ? item.remain.remain : null;
      }
      return item.remain;
    },
    remainText(item) {
      const amount = this.remainAmount(item);
      if (amount == null || amount === "") return "—";
      const formatted = this.$numberFormat
        ? this.$numberFormat(amount)
        : String(amount);
      const symbol =
        (this.$store.state.currency && this.$store.state.currency.name) ||
        this.$store.state.currencySymbol ||
        "";
      return symbol ? formatted + " " + symbol : formatted;
    },
    remainTone(item) {
      const amount = parseFloat(this.remainAmount(item));
      if (isNaN(amount) || amount === 0) return "clear";
      return amount > 0 ? "debtor" : "creditor";
    },
    remainToneClass(item) {
      const tone = this.remainTone(item);
      if (tone === "debtor") return "clm-card__amount-value--debtor";
      if (tone === "creditor") return "clm-card__amount-value--creditor";
      return "";
    },
    openDetails(item) {
      this.detailItem = item;
      this.detailSheet = true;
    },
    askDelete(item) {
      this.moreSheet = false;
      this.detailSheet = false;
      this.deleteGroupMode = false;
      this.customerList.deleteItem = item;
      this.deleteSheet = true;
    },
    askGroupDelete() {
      if (!this.selectedItems.length) return;
      // Sync into shell.selected only for the group action (same as invoice).
      this.syncSelection();
      this.customerList.deleteItem = null;
      this.deleteGroupMode = true;
      this.deleteSheet = true;
    },
    cancelDelete() {
      this.deleteSheet = false;
      this.deleteGroupMode = false;
    },
    confirmDelete() {
      this.deleteSheet = false;
      if (this.customerList.selected && this.customerList.selected.length > 0) {
        this.customerList.removegroup();
      } else {
        this.customerList.remove();
      }
      if (this.deleteGroupMode) {
        this.deleteGroupMode = false;
        this.exitSelectionMode();
      }
    },
    toggleSelectionMode() {
      // Keep picks locally while mode is on; shell.selected is synced only
      // when a group action runs (shell clears selected after removegroup).
      this.selectionMode = !this.selectionMode;
      if (!this.selectionMode) {
        this.selectedItems = [];
        this.customerList.selected = [];
      }
    },
    exitSelectionMode() {
      this.selectionMode = false;
      this.selectedItems = [];
      this.customerList.selected = [];
    },
    isSelected(item) {
      return this.selectedItems.some((i) => i.id === item.id);
    },
    toggleSelect(item) {
      if (this.isSelected(item)) {
        this.selectedItems = this.selectedItems.filter(
          (i) => i.id !== item.id
        );
      } else {
        this.selectedItems = this.selectedItems.concat([item]);
      }
    },
    selectAllLoaded() {
      const seen = {};
      this.selectedItems.forEach((i) => {
        seen[i.id] = true;
      });
      this.selectedItems = this.selectedItems.concat(
        this.displayItems.filter((i) => !seen[i.id])
      );
    },
    clearSelection() {
      this.selectedItems = [];
    },
    syncSelection() {
      this.customerList.selected = this.selectedItems.slice();
    },
    selectedRowNumber(item) {
      const idx = this.displayItems.findIndex((i) => i.id === item.id);
      return idx >= 0 ? idx + 1 : "";
    },
    runMoreAction(name) {
      this.moreSheet = false;
      this.runNamedAction(name);
    },
    onCopyLink() {
      this.moreSheet = false;
      this.detailSheet = false;
      if (typeof this.copied === "function") this.copied();
    },
    runNamedAction(name) {
      const item = this.detailItem;
      const list = this.customerList;
      this.detailSheet = false;
      if (!item) return;
      // Same methods and conditions as the desktop row action menu.
      if (name === "edit") list.edit(item);
      else if (name === "turnover") list.turnover(item);
      else if (name === "pay") list.payment(item, "pay");
      else if (name === "recieve") list.payment(item, "recieve");
      else if (name === "events") list.events(item);
      else if (name === "teacherCostList") list.teacherCostList(item);
      else if (name === "remainAccountSms") list.remainAccountSms(item);
      else if (name === "openCardDialog") list.openCardDialog(item);
      else if (name === "openTaskDialog") list.openTaskDialog(item);
      else if (name === "openTaskDialogList") list.openTaskDialogList(item);
      else if (name === "remove") this.askDelete(item);
    },
    detailRows(item) {
      if (!item) return [];
      const rows = [];
      const push = (label, value, kind, tone) =>
        rows.push({
          label,
          value: value == null || value === "" ? "—" : value,
          kind: kind || null,
          tone: tone || null,
        });
      push(this.$t("id"), item.id);
      if (item.code) push(this.$t("code"), item.code);
      push(this.$t("mobile"), item.mobile);
      push(this.$t("phone"), item.phone);
      push(this.$t("email"), item.email);
      push(this.$t("national-code"), item.national_code);
      push(
        this.$t("category"),
        item.category && item.category.name ? item.category.name : null
      );
      push(
        this.$t("branch"),
        item.meta && item.meta.branch ? item.meta.branch.name : null
      );
      push(this.$t("address"), item.address);
      // fin-id + integrator IDs render in detailIdRows (desktop "سایر" style).
      if (this.customerList.hasDobarePermission) {
        const credit =
          item.customer_club_credit &&
          typeof this.customerList.resolveClubCredit === "function"
            ? this.customerList.resolveClubCredit(item)
            : this.$t("haveNot");
        push(this.$t("club-credit"), credit);
      }
      const remain = this.remainAmount(item);
      push(
        this.$t("remainPrice"),
        remain == null || remain === ""
          ? null
          : this.remainText(item),
        "remain",
        this.remainTone(item)
      );
      if (item.last_status && item.last_status.status) {
        push(this.$t("status"), item.last_status.status.name);
      }
      return rows;
    },
    integratorValue(item, key) {
      const list = (item && item.integrator) || [];
      const found = list.find((entry) => entry && entry.key === key);
      return found && found.value != null ? found.value : null;
    },
    detailIdIcon(key) {
      try {
        if (key === "woo") return require("@/assets/woo.png");
        if (key === "digikala") return require("@/assets/digikala.png");
        if (key === "sazito") return require("@/assets/sazito(1).png");
        if (key === "magnet")
          return require("@/assets/integrators/logo-magnet.png");
        if (key === "webzi") return require("@/assets/webzi.png");
      } catch (e) {
        return "";
      }
      return "";
    },
    detailIdRows(item) {
      // Same IDs shown in the desktop "سایر" / content column.
      if (!item) return [];
      const rows = [];
      const push = (label, value, icon) => {
        if (value == null || value === "") return;
        rows.push({ label, value: String(value), icon: icon || null });
      };
      if (item.fin != null && item.fin.fin_code != null) {
        push(this.$t("fin-id"), item.fin.fin_code);
      }
      const woo =
        item.woocommerceItems &&
        item.woocommerceItems.length > 0 &&
        item.woocommerceItems[0].woocommerceId
          ? item.woocommerceItems[0].woocommerceId
          : null;
      push(this.$t("id"), woo, this.detailIdIcon("woo"));
      push(
        this.$t("id"),
        this.integratorValue(item, "digikalaId"),
        this.detailIdIcon("digikala")
      );
      push(
        this.$t("id"),
        this.integratorValue(item, "sazitoId"),
        this.detailIdIcon("sazito")
      );
      push(
        this.$t("id"),
        this.integratorValue(item, "magnetId"),
        this.detailIdIcon("magnet")
      );
      push(
        this.$t("id"),
        this.integratorValue(item, "webziId"),
        this.detailIdIcon("webzi")
      );
      return rows;
    },
    detailContentPreview(item) {
      if (!item || !item.content) return "";
      if (item.deleted_at) return item.content;
      return item.content.length > 20
        ? item.content.substr(0, 20) + "..."
        : item.content;
    },
    onCopyId() {
      if (typeof this.copied === "function") this.copied();
      else if (
        this.customerList &&
        typeof this.customerList.copied === "function"
      ) {
        this.customerList.copied();
      }
    },
    maybeOpenExtension(item) {
      const uid = this.$store.state.userId;
      const allowed =
        uid === "mWZdPLzdKg" ||
        uid === "LYqaQM7anj" ||
        uid === "z3YaOKgaxq" ||
        uid === "4zbqlpZrap";
      if (!allowed || !item) return;
      this.customerList.openExtensionDialog(item);
    },
    loadMore() {
      if (!this.displayItems.length) return;
      if (this.customerList.loading || this.appending) return;
      if (this.currentPage >= (this.customerList.pageCount || 1)) return;
      this.appending = true;
      this.customerList.tableOptions = Object.assign(
        {},
        this.customerList.tableOptions,
        { page: this.currentPage + 1 }
      );
    },
    openPicker(refName) {
      const comp = this.$refs[refName];
      if (comp && typeof comp.openMobileDialog === "function") {
        comp.openMobileDialog();
      }
    },
    pickFinancialStatus(value) {
      // Same shell field as desktop v-select; tap again clears (like clearable).
      if (this.customerList.financialStatus === value) {
        this.customerList.financialStatus = null;
      } else {
        this.customerList.financialStatus = value;
      }
    },
    pickerSummary(refName, value) {
      if (!this.hasValue(value)) return "—";
      const comp = this.$refs[refName];
      const items = (comp && comp.items) || [];
      const arr = Array.isArray(value) ? value : [value];
      const names = [];
      arr.forEach((v) => {
        if (v && typeof v === "object") {
          if (v.name || v.text) names.push(v.name || v.text);
        } else {
          const found = items.find((i) => i && i.id === v);
          if (found && found.name) names.push(found.name);
        }
      });
      if (names.length) return names.join(" · ");
      return String(arr.length);
    },
    openFilterGroup(key) {
      this.filterGroup = key;
      this.filterSheet = false;
      if (key === "custom") {
        this.loadFilterCustomFields();
        this.loadFilterCustomKeys();
      }
      this.$nextTick(() => {
        this.filterGroupSheet = true;
      });
    },
    loadFilterCustomFields() {
      const source = Array.isArray(this.customerList.customFields)
        ? this.customerList.customFields
        : [];
      this.filterCustomItems = source.map((item) => ({
        key: item && item.key != null ? item.key : null,
        value: item && item.value != null ? item.value : null,
      }));
    },
    syncFilterCustomFields() {
      // Same shape the desktop custom-fields component writes on the shell.
      this.customerList.customFields = this.filterCustomItems.map((item) => ({
        key: item.key,
        value: item.value,
      }));
    },
    addFilterCustomField() {
      this.filterCustomItems.push({ key: null, value: null });
      this.syncFilterCustomFields();
    },
    removeFilterCustomField(index) {
      this.filterCustomItems.splice(index, 1);
      this.syncFilterCustomFields();
    },
    loadFilterCustomKeys() {
      clearTimeout(this.filterCustomKeyTimer);
      this.filterCustomKeyTimer = setTimeout(() => {
        this.$axios
          .get(this.$endpoint + "getdetail", {
            params: {
              select: "accountCustomFields",
              search: this.filterCustomSearch,
            },
          })
          .then((res) => {
            this.filterCustomKeyItems = res.data || [];
          })
          .catch((err) => {
            if (typeof this.customerList.serverErrorHandeler === "function") {
              this.customerList.serverErrorHandeler(err);
            }
          });
      }, 400);
    },
    backToFilterMain() {
      if (this.filterGroup === "custom") {
        this.filterCustomSearch = null;
        this.filterCustomItems = [];
        this.filterCustomKeyItems = [];
      }
      this.filterGroupSheet = false;
      this.$nextTick(() => {
        this.filterSheet = true;
      });
    },
    toggleFlag(field) {
      // Same checkbox semantics as desktop filter dialog (value="active").
      if (this.customerList[field] === "active") {
        this.customerList[field] = null;
      } else {
        this.customerList[field] = "active";
      }
    },
    hasValue(v) {
      if (Array.isArray(v)) return v.length > 0;
      return v !== null && v !== undefined && v !== "";
    },
    groupHasValue(key) {
      const list = this.customerList;
      if (key === "status") {
        // Default shell status is "active"; only treat as "set" when
        // lead is on, status is cleared/off, or financialStatus is set.
        return (
          list.lead === "active" ||
          list.status !== "active" ||
          this.hasValue(list.financialStatus)
        );
      }
      if (key === "category") {
        return (
          this.hasValue(list.category) ||
          this.hasValue(list.attractionMethod) ||
          this.hasValue(list.tag) ||
          this.hasValue(list.branch)
        );
      }
      if (key === "registerar") {
        return this.hasValue(list.registerar);
      }
      if (key === "custom") return this.hasValue(list.customFields);
      return false;
    },
    groupSubtitle(key) {
      const list = this.customerList;
      if (key === "status") {
        const parts = [];
        if (list.lead === "active") parts.push(this.$t("lead"));
        if (list.status === "active") parts.push(this.$t("active"));
        const fin = (list.financialStatusItems || []).find(
          (i) => i && i.value === list.financialStatus
        );
        if (fin) parts.push(fin.text);
        return parts.length
          ? parts.join(" · ")
          : this.$t("lead") +
              " · " +
              this.$t("active") +
              " · " +
              this.$t("financial-status");
      }
      if (key === "category") {
        return (
          this.$t("category") +
          " · " +
          this.$t("attractionMethod") +
          " · " +
          this.$t("tag") +
          " · " +
          this.$t("branch")
        );
      }
      if (key === "registerar") {
        return this.$t("registerar");
      }
      if (key === "custom") {
        return this.$t("invoice-mobile-custom-field-extras-subtitle");
      }
      return "";
    },
    applyFilter() {
      this.filterSheet = false;
      this.filterGroupSheet = false;
      this.appending = false;
      this.customerList.tableOptions = Object.assign(
        {},
        this.customerList.tableOptions,
        { page: 1 }
      );
      this.customerList.getItems();
    },
    clearFilter() {
      // Reset to the same shell defaults the desktop filter starts from.
      const list = this.customerList;
      list.lead = null;
      list.status = "active";
      list.financialStatus = null;
      list.category = null;
      list.attractionMethod = null;
      list.registerar = null;
      list.tag = null;
      list.branch = null;
      list.customFields = null;
      this.filterCustomItems = [];
      this.applyFilter();
    },
  },
};
</script>

<style scoped>
.clm {
  display: flex;
  flex-direction: column;
  padding: 0 12px 12px;
  background: #ffffff;
  min-height: calc(100vh - 52px);
  box-sizing: border-box;
  padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));
}
.clm--selecting .clm__list {
  padding-bottom: 88px;
}
.clm__header {
  position: sticky;
  top: 52px;
  z-index: 4;
  background: #ffffff;
  padding: 6px 0 10px;
  border-bottom: 1px solid #eef1f4;
  margin-bottom: 10px;
}
.clm__bar {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-bottom: 8px;
}
.clm__bar-actions {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  min-width: 80px;
}
.clm__title {
  flex: 1 1 auto;
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #263238;
  text-align: center;
}
.clm__bar-btn {
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}
.clm__bar-btn:active {
  background: rgba(91, 124, 153, 0.1);
}
.clm__bar-btn--create {
  background: rgba(91, 124, 153, 0.1);
}
.clm__bar-btn--create:active {
  background: rgba(91, 124, 153, 0.18);
}
.clm__bar-btn--back {
  flex: 0 0 40px;
}
.clm__search-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.clm__search {
  flex: 1 1 auto;
  min-width: 0;
  height: 44px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  border-radius: 10px;
  background: #f3f5f7;
}
.clm__search-icon {
  flex: 0 0 auto;
}
.clm__search-input {
  flex: 1 1 auto;
  min-width: 0;
  border: 0;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #263238;
  text-align: right;
}
.clm__search-clear {
  flex: 0 0 auto;
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
}
.clm__filter-btn {
  flex: 0 0 44px;
  height: 44px;
  border: 1px solid #e0e4e8;
  border-radius: 10px;
  background: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
}
.clm__filter-btn:active {
  background: rgba(91, 124, 153, 0.1);
}
.clm__filter-btn--active {
  background: rgba(21, 101, 192, 0.1);
  border-color: rgba(21, 101, 192, 0.35);
}
.clm__select-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 8px;
  padding: 6px 10px;
  border: 1px solid #e8edf2;
  border-radius: 10px;
  background: #f8fafc;
}
.clm__select-bar-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 6px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  font-size: 12px;
  font-weight: 600;
  color: #37474f;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.clm__select-bar-btn:active {
  background: rgba(91, 124, 153, 0.12);
}
.clm__select-count {
  font-size: 12px;
  font-weight: 700;
  color: #5b7c99;
}
.clm__state {
  display: flex;
  justify-content: center;
  padding: 40px 0;
  color: #607d8b;
  font-size: 13px;
}
.clm__state--empty {
  flex: 1 1 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: calc(100vh - 220px);
  padding: 32px 16px 24px;
  background: #ffffff;
}
.clm__empty-logo {
  width: 72px;
  height: 72px;
  object-fit: contain;
  opacity: 0.85;
}
.clm__empty-text {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #78909c;
  text-align: center;
}
.clm__state--more {
  padding: 14px 0;
}
.clm__list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.clm-card {
  position: relative;
  background: #f8fafc;
  border: 1px solid #e8edf2;
  border-radius: 10px;
  padding: 12px;
  transition: transform 0.15s ease;
}
.clm-card--selected {
  transform: scale(0.99);
  border-color: rgba(21, 101, 192, 0.45);
}
.clm-card__select-overlay {
  position: absolute;
  inset: 0;
  z-index: 3;
  border-radius: 10px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.clm-card__select-overlay--on {
  background: rgba(38, 50, 56, 0.12);
}
.clm-card__check {
  position: absolute;
  top: 8px;
  left: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #0d47a1;
  box-shadow: 0 2px 6px rgba(13, 71, 161, 0.4);
}
.clm-bulkbar {
  position: fixed;
  right: 12px;
  left: 12px;
  bottom: calc(16px + env(safe-area-inset-bottom, 0px));
  z-index: 6;
  display: flex;
  gap: 4px;
  padding: 8px;
  border: 1px solid #e8edf2;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  box-shadow: 0 8px 24px rgba(38, 50, 56, 0.14);
}
.clm-bulkbar__btn {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  min-height: 48px;
  padding: 6px 2px;
  border: 0;
  border-radius: 10px;
  background: rgba(91, 124, 153, 0.07);
  font-size: 10px;
  font-weight: 600;
  line-height: 1.25;
  text-align: center;
  color: #37474f;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.clm-bulkbar__btn:active {
  background: rgba(91, 124, 153, 0.15);
}
.clm-bulkbar__btn:disabled {
  opacity: 0.4;
  cursor: default;
}
.clm-bulkbar__btn--danger {
  color: #e53935;
  background: rgba(229, 57, 53, 0.06);
}
.clm-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.clm-card__identity {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  flex: 1 1 auto;
}
.clm-card__avatar {
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  object-fit: cover;
  background: #eceff1;
}
.clm-card__name-link {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  min-width: 0;
  max-width: 100%;
  padding: 2px 4px;
  margin: -2px -4px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #5b7c99;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.clm-card__name-link:active {
  background: rgba(91, 124, 153, 0.12);
}
.clm-card__name {
  font-size: 14px;
  font-weight: 700;
  color: #5b7c99;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.clm-card__number {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 600;
  color: #5b7c99;
  background: rgba(91, 124, 153, 0.1);
  border-radius: 10px;
  padding: 2px 8px;
}
.clm-card__amounts {
  margin-top: 10px;
  border-top: 1px dashed rgba(144, 164, 174, 0.35);
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.clm-card__amount-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.clm-card__amount-label {
  font-size: 12px;
  color: #78909c;
}
.clm-card__amount-value {
  font-size: 13px;
  font-weight: 700;
  color: #37474f;
}
.clm-card__amount-value--debtor {
  color: #e53935;
}
.clm-card__amount-value--creditor {
  color: #2e7d32;
}
.clm-card__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 10px;
}
.clm-card__actions {
  display: flex;
  gap: 6px;
}
.clm-btn {
  flex: 0 0 auto;
  height: 28px;
  padding: 0 10px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.clm-btn .v-icon {
  margin-inline-end: 2px;
}
.clm-btn--primary {
  border: 0;
  background: #5b7c99;
  color: #ffffff;
}
.clm-btn--primary:active {
  background: #4d6a84;
}
.clm-btn--outline {
  border: 1px solid #cfd8dc;
  background: #ffffff;
  color: #5b7c99;
}
.clm-btn--outline:active {
  background: rgba(91, 124, 153, 0.08);
}
.clm-btn--danger {
  border: 1px solid rgba(229, 57, 53, 0.35);
  background: rgba(229, 57, 53, 0.06);
  color: #e53935;
}
.clm-btn--danger:active {
  background: #fce4ec;
}
.clm-status-btn {
  flex: 0 0 auto;
  height: 28px;
  padding: 0 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  background: rgba(91, 124, 153, 0.08);
  color: #5b7c99;
}
.clm-status-btn--debtor {
  background: rgba(229, 57, 53, 0.08);
  color: #e53935;
}
.clm-status-btn--creditor {
  background: rgba(46, 125, 50, 0.08);
  color: #2e7d32;
}
.clm-status-btn--clear {
  background: rgba(67, 160, 71, 0.1);
  color: #43a047;
}
.clm__sentinel {
  height: 1px;
}

.clm-sheet {
  border-radius: 10px 10px 0 0 !important;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
}
.clm-sheet--filter {
  max-height: 92vh;
  border-radius: 20px 20px 0 0 !important;
}
.clm-sheet__handle {
  flex: 0 0 auto;
  width: 44px;
  height: 4px;
  border-radius: 10px;
  background: #cfd8dc;
  margin: 10px auto 2px;
}
.clm-sheet__header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px 10px;
  border-bottom: 1px solid #eef1f4;
}
.clm-sheet__header-spacer {
  flex: 0 0 40px;
  width: 40px;
}
.clm-sheet__header-side {
  flex: 1 1 0;
  display: flex;
  align-items: center;
  min-width: 0;
}
.clm-sheet__header-side--end {
  justify-content: flex-end;
}
.clm-sheet__num-chip {
  display: inline-flex;
  align-items: center;
  height: 26px;
  padding: 0 10px;
  border-radius: 10px;
  background: rgba(135, 158, 182, 0.14);
  border: 1px solid rgba(135, 158, 182, 0.28);
  color: #5b7c99;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.clm-sheet__title {
  flex: 1 1 auto;
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  color: #263238;
}
.clm-sheet__quickbar {
  flex: 0 0 auto;
  display: flex;
  gap: 6px;
  padding: 8px 12px 0;
}
.clm-sheet__quick {
  position: relative;
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  height: 46px;
  padding: 4px 2px;
  border: 1px solid #e8edf2;
  border-radius: 10px;
  background: rgba(91, 124, 153, 0.07);
  font-size: 9px;
  font-weight: 600;
  line-height: 1.25;
  text-align: center;
  color: #37474f;
  cursor: pointer;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
}
.clm-sheet__quick .v-icon {
  font-size: 18px !important;
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
}
.clm-sheet__quick:active {
  background: rgba(91, 124, 153, 0.14);
}
.clm-sheet__quick-badge {
  position: absolute;
  top: 2px;
  left: 4px;
  min-width: 14px;
  height: 14px;
  padding: 0 3px;
  border-radius: 999px;
  background: #e53935;
  color: #ffffff;
  font-size: 9px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.clm-sheet__action-badge {
  margin-inline-start: auto;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: #e53935;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.clm-sheet__customer-block {
  flex: 0 0 auto;
  background: #edf2f7;
  border-radius: 10px;
  padding: 10px 14px;
  margin: 6px 16px 0;
}
.clm-sheet__customer-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.clm-sheet__customer-name {
  font-size: 14px;
  font-weight: 800;
  color: #263238;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  max-width: 70%;
}
.clm-sheet__customer-block .clm-sheet__linkrow {
  margin: 8px 0 0;
  background: rgba(255, 255, 255, 0.75);
}
.clm-sheet__customer-block .clm-sheet__linkrow:active {
  background: rgba(255, 255, 255, 0.95);
}
.clm-sheet__linkrow {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 40px;
  margin: 6px 0 2px;
  padding: 0 10px;
  border: 1px solid rgba(0, 150, 136, 0.16);
  border-radius: 10px;
  background: rgba(0, 150, 136, 0.07);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.clm-sheet__linkrow:active {
  background: rgba(0, 150, 136, 0.15);
}
.clm-sheet__linkrow-text {
  flex: 1 1 auto;
  font-size: 12.5px;
  font-weight: 700;
  color: #00796b;
  text-align: right;
}
.clm-sheet__body {
  overflow-y: auto;
  padding: 8px 16px 20px;
}
.clm-sheet__card {
  background: #f8fafc;
  border: 1px solid #e8edf2;
  border-radius: 10px;
  padding: 4px 14px;
}
.clm-sheet__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #e8edf2;
}
.clm-sheet__card .clm-sheet__row:last-child {
  border-bottom: 0;
}
.clm-sheet__row--band {
  margin: 0 -14px;
  padding: 8px 14px;
  border-bottom-color: rgba(91, 124, 153, 0.12);
  background: rgba(91, 124, 153, 0.05);
}
.clm-sheet__row-label {
  flex: 0 0 auto;
  font-size: 12px;
  color: #90a4ae;
}
.clm-sheet__row-value {
  font-size: 13px;
  font-weight: 600;
  color: #263238;
  text-align: left;
  word-break: break-word;
}
.clm-sheet__row-value--remain {
  font-weight: 800;
}
.clm-sheet__row-value--debtor {
  color: #d32f2f;
}
.clm-sheet__row-value--creditor {
  color: #2e7d32;
}
.clm-sheet__tags {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: flex-end;
  max-width: 62%;
}
.clm-sheet__row--id {
  align-items: center;
}
.clm-sheet__id-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.clm-sheet__id-icon {
  width: 18px;
  height: 18px;
  border-radius: 0;
  object-fit: contain;
}
.clm-sheet__id-value {
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
  color: #78909c;
  text-align: left;
  font: inherit;
}
.clm-sheet__row--chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: flex-end;
}
.clm-sheet__row-value--muted {
  color: #90a4ae;
  font-weight: 500;
}
.clm-sheet__actions {
  margin-top: 14px;
  display: flex;
  flex-direction: column;
}
.clm-sheet__actions--sheet {
  margin-top: 0;
}
.clm-sheet__action {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  height: 42px;
  padding: 0 6px;
  border: 0;
  border-bottom: 1px solid #e8edf2;
  border-radius: 10px;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  color: #37474f;
  text-align: right;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.clm-sheet__action:active {
  background: rgba(91, 124, 153, 0.08);
}
.clm-sheet__action--danger {
  color: #e53935;
}
.clm-sheet__action--log {
  cursor: default;
}
.clm-sheet__action--log > div {
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
}
.clm-sheet__action--log ::v-deep .v-list-item {
  flex: 1 1 auto;
  min-height: 42px;
  height: 42px;
  padding: 0;
}
.clm-sheet__action--log ::v-deep .v-list-item__icon {
  margin: 0 !important;
  min-width: 19px;
  align-self: center;
}
.clm-sheet__action--log ::v-deep .v-list-item__icon .v-icon {
  font-size: 19px !important;
  color: #5b7c99 !important;
}
.clm-sheet__action--log ::v-deep .v-list-item__title {
  margin-inline-start: 10px;
  font-size: 13px;
  font-weight: 600;
  color: #37474f;
  text-align: right;
}
.clm-confirm-sheet {
  border-radius: 20px 20px 0 0 !important;
  padding: 8px 16px 16px;
  background: #fff !important;
}
.clm-confirm-sheet__handle {
  width: 40px;
  height: 4px;
  margin: 4px auto 14px;
  border-radius: 999px;
  background: #cfd8dc;
}
.clm-confirm-sheet__icon {
  width: 52px;
  height: 52px;
  margin: 0 auto 10px;
  border-radius: 50%;
  background: rgba(229, 57, 53, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}
.clm-confirm-sheet__title {
  text-align: center;
  font-size: 18px;
  font-weight: 800;
  color: #212121;
  margin: 0 0 8px;
}
.clm-confirm-sheet__subtitle {
  margin: 0 0 16px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: #607d8b;
  line-height: 1.6;
}
.clm-confirm-sheet__rows {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 18px;
}
.clm-confirm-sheet__items {
  max-height: 168px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  border: 1px solid #e8edf2;
  border-radius: 10px;
  background: #f8fafc;
  padding: 4px 12px;
}
.clm-confirm-sheet__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 0;
  border-bottom: 1px solid #e8edf2;
}
.clm-confirm-sheet__item:last-child {
  border-bottom: 0;
}
.clm-confirm-sheet__item-main {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
}
.clm-confirm-sheet__item-index {
  flex: 0 0 auto;
  min-width: 16px;
  font-size: 11px;
  font-weight: 700;
  color: #90a4ae;
  text-align: center;
}
.clm-confirm-sheet__item-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12.5px;
  font-weight: 600;
  color: #37474f;
}
.clm-confirm-sheet__item-number {
  flex: 0 0 auto;
  font-size: 11.5px;
  font-weight: 700;
  color: #5b7c99;
}
.clm-confirm-sheet__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 48px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #f5f7f9;
  font-size: 13px;
  font-weight: 600;
  color: #607d8b;
}
.clm-confirm-sheet__row strong {
  font-size: 14px;
  font-weight: 800;
  color: #263238;
  text-align: left;
}
.clm-confirm-sheet__actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.clm-confirm-sheet__yes {
  border-radius: 12px !important;
  font-weight: 800 !important;
  letter-spacing: 0 !important;
}
.clm-confirm-sheet__no {
  border-radius: 12px !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
}
.clm-sheet__back {
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}
.clm-sheet__back:active {
  background: rgba(91, 124, 153, 0.1);
}
.clm-sheet__footer {
  flex: 0 0 auto;
  display: flex;
  gap: 8px;
  padding: 10px 12px calc(10px + env(safe-area-inset-bottom, 0px));
  border-top: 1px solid #eef1f4;
  background: #ffffff;
}
.clm-sheet__btn {
  flex: 1 1 0;
  height: 44px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.clm-sheet__btn--primary {
  border: 0;
  background: #5b7c99;
  color: #ffffff;
}
.clm-sheet__btn--primary:active {
  background: #4d6a84;
}
.clm-sheet__btn--ghost {
  border: 1px solid #cfd8dc;
  background: #ffffff;
  color: #546e7a;
}
.clm-sheet__btn--ghost:active {
  background: rgba(91, 124, 153, 0.08);
}

.clm-filter-nav {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 4px 0;
  background: #ffffff;
}
.clm-filter-nav__item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 12px;
  padding: 12px 16px;
  border: 0;
  border-bottom: 1px solid #eeeeee;
  background: #fff;
  text-align: right;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.clm-filter-nav__item:active {
  background: #f7f9fc;
}
.clm-filter-nav__item:last-child {
  border-bottom: 0;
}
.clm-filter-nav__icon {
  flex: 0 0 auto;
}
.clm-filter-nav__texts {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 1 auto;
  min-width: 0;
  text-align: right;
}
.clm-filter-nav__item-title {
  display: block;
  width: 100%;
  font-size: 14px;
  font-weight: 700;
  color: #212121;
  line-height: 1.35;
  text-align: right;
}
.clm-filter-nav__item-sub {
  display: block;
  width: 100%;
  margin-top: 2px;
  font-size: 12px;
  font-weight: 400;
  color: #90a4ae;
  line-height: 1.35;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.clm-filter-nav__dot {
  flex: 0 0 auto;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #5b7c99;
}

.clm-filter-fields {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 14px 16px 6px;
  background: #ffffff;
}
.clm-filter-fields > * {
  margin-bottom: 14px;
}
.clm-picker-host {
  display: none !important;
}
.clm-picker-cover__clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex: 0 0 auto;
}
.clm-f-field-wrap {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.clm-f-field-wrap__label {
  display: block;
  flex: 0 0 auto;
  font-size: 13px;
  font-weight: 600;
  color: #455a64;
  text-align: right;
  line-height: 1.4;
  margin: 0 2px 4px;
}
.clm-f-field.v-input,
.clm-f-field ::v-deep .v-input {
  margin: 0 !important;
  padding: 0 !important;
  font-size: 14px;
}
.clm-f-field ::v-deep .v-text-field,
.clm-f-field.v-input.v-text-field {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
.clm-f-field ::v-deep .v-text-field__details,
.clm-f-field ::v-deep .v-messages {
  display: none !important;
  min-height: 0 !important;
}
.clm-f-field ::v-deep .v-input__control,
.clm-f-field.v-input ::v-deep .v-input__control {
  min-height: 40px !important;
}
.clm-f-field ::v-deep .v-input__slot,
.clm-f-field.v-input ::v-deep .v-input__slot {
  min-height: 40px !important;
  margin: 0 !important;
  padding: 0 12px !important;
  border: 1px solid #cfd8dc !important;
  border-radius: 10px !important;
  background: #fff !important;
  box-shadow: none !important;
}
.clm-f-field ::v-deep fieldset {
  display: none !important;
}
.clm-f-field ::v-deep .v-input__slot::before,
.clm-f-field ::v-deep .v-input__slot::after,
.clm-f-field.v-input ::v-deep .v-input__slot::before,
.clm-f-field.v-input ::v-deep .v-input__slot::after {
  display: none !important;
}
.clm-f-field ::v-deep .v-input__append-inner,
.clm-f-field ::v-deep .v-input__prepend-inner,
.clm-f-field.v-input ::v-deep .v-input__append-inner,
.clm-f-field.v-input ::v-deep .v-input__prepend-inner {
  margin-top: 0 !important;
  align-self: center !important;
}
.clm-f-field ::v-deep .v-label,
.clm-f-field.v-input ::v-deep .v-label {
  display: none !important;
}
.clm-f-field ::v-deep input,
.clm-f-field ::v-deep .v-select__selection,
.clm-f-field.v-input ::v-deep input,
.clm-f-field.v-input ::v-deep .v-select__selection {
  margin: 0 !important;
  font-size: 14px;
  color: #263238;
}
.clm-f-field ::v-deep .v-icon,
.clm-f-field.v-input ::v-deep .v-icon {
  color: #78909c !important;
  font-size: 20px !important;
}
.clm-cf__hint {
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 600;
  color: #78909c;
  line-height: 1.5;
}
.clm-cf__add {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  min-height: 44px;
  margin-bottom: 12px;
  border: 1px solid #c5d0e0;
  border-radius: 10px;
  background: #e8edf5;
  color: #5b7c99;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.clm-cf__add:active {
  background: #d9e1ec;
}
.clm-cf__empty {
  padding: 16px;
  border: 1px dashed #cfd8dc;
  border-radius: 12px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: #90a4ae;
}
.clm-cf-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 12px;
  padding: 12px;
  border: 1px solid #e0e4e8;
  border-radius: 12px;
  background: #fff;
}
.clm-cf-card__type {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}
.clm-cf-card__type-field {
  flex: 1 1 auto;
  min-width: 0;
  margin: 0;
}
.clm-cf-card__remove {
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #f8bbd0;
  border-radius: 10px;
  background: #fce4ec;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.clm-cf-card__input {
  width: 100%;
  height: 40px;
  padding: 0 10px;
  border: 1px solid #cfd8dc;
  border-radius: 10px;
  outline: none;
  background: #fff;
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  color: #37474f;
  box-sizing: border-box;
}
.clm-cf-card__input--text {
  text-align: right;
  font-weight: 600;
}
.clm-cf-card .clm-f-field {
  flex: none !important;
  width: 100%;
  height: 40px !important;
  max-height: 40px !important;
  margin: 0 !important;
  overflow: hidden !important;
}
.clm-cf-card .clm-f-field.v-input {
  margin: 0 !important;
  min-height: 40px !important;
  height: 40px !important;
  max-height: 40px !important;
}
.clm-cf-card .clm-f-field ::v-deep .v-input__control,
.clm-cf-card .clm-f-field ::v-deep .v-input__slot {
  margin: 0 !important;
  min-height: 40px !important;
  height: 40px !important;
  max-height: 40px !important;
}
.clm-cf-card .clm-f-field-wrap__label {
  margin: 0 2px 4px;
}
.clm-cf-card:last-child {
  margin-bottom: 0;
}
.clm-cf-card .clm-f-field ::v-deep .v-select__selections {
  flex-wrap: nowrap;
  overflow: hidden;
  min-height: 0 !important;
  padding: 0 !important;
}
.clm-cf-card .clm-f-field ::v-deep .v-select__selection {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 !important;
}
.clm-f-picker-field {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 40px;
  min-height: 40px;
  margin: 0;
  padding: 0 12px;
  border: 1px solid #cfd8dc;
  border-radius: 10px;
  background: #fff;
  box-sizing: border-box;
  cursor: pointer;
  text-align: right;
  -webkit-tap-highlight-color: transparent;
}
.clm-f-picker-field:active {
  background: #eef4f8;
  border-color: #90caf9;
}
.clm-f-picker-field__text {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 14px;
  color: #263238;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clm-toggle-row {
  display: flex;
  align-items: stretch;
  gap: 8px;
}
.clm-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1 1 0;
  min-width: 0;
  min-height: 48px;
  padding: 10px 12px;
  border: 1px solid #e8edf2;
  border-radius: 10px;
  background: #f8fafc;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.clm-toggle__label {
  font-size: 13px;
  font-weight: 600;
  color: #37474f;
}
.clm-toggle__switch {
  position: relative;
  width: 42px;
  height: 24px;
  border-radius: 999px;
  background: #cfd8dc;
  flex: 0 0 auto;
  transition: background 0.15s ease;
}
.clm-toggle__switch::after {
  content: "";
  position: absolute;
  top: 2px;
  right: 2px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  transition: transform 0.15s ease;
}
.clm-toggle--on {
  border-color: rgba(91, 124, 153, 0.35);
  background: rgba(91, 124, 153, 0.08);
}
.clm-toggle--on .clm-toggle__switch {
  background: #5b7c99;
}
.clm-toggle--on .clm-toggle__switch::after {
  transform: translateX(-18px);
}
.clm-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.clm-chip {
  flex: 1 1 0;
  min-width: 0;
  min-height: 40px;
  padding: 0 10px;
  border: 1px solid #cfd8dc;
  border-radius: 10px;
  background: #ffffff;
  font-size: 13px;
  font-weight: 600;
  color: #546e7a;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.clm-chip:active {
  background: #eef4f8;
}
.clm-chip--on {
  border-color: rgba(91, 124, 153, 0.45);
  background: rgba(91, 124, 153, 0.12);
  color: #37474f;
}
</style>
